// extracted by mini-css-extract-plugin
var _1 = "CompaniesListDataStyle-module__company-description___E8R2M";
var _2 = "CompaniesListDataStyle-module__company-details___GSx_b";
var _3 = "CompaniesListDataStyle-module__company-logo___scvTd";
var _4 = "CompaniesListDataStyle-module__company-name___PtmE8";
var _5 = "CompaniesListDataStyle-module__company-description___E8R2M";
var _6 = "CompaniesListDataStyle-module__company-details___GSx_b";
var _7 = "CompaniesListDataStyle-module__company-logo___scvTd";
var _8 = "CompaniesListDataStyle-module__company-name___PtmE8";
var _9 = "CompaniesListDataStyle-module__item-details___V8oox";
var _a = "CompaniesListDataStyle-module__item-raised___pibJu";
var _b = "CompaniesListDataStyle-module__item-website-break___OrU4X";
var _c = "CompaniesListDataStyle-module__item-details___V8oox";
var _d = "CompaniesListDataStyle-module__item-raised___pibJu";
var _e = "CompaniesListDataStyle-module__item-website-break___OrU4X";
var _f = "CompaniesListDataStyle-module__keep-whitespace___ghwa6";
var _10 = "CompaniesListDataStyle-module__keep-whitespace___ghwa6";
var _11 = "CompaniesListDataStyle-module__label____lo1K";
var _12 = "CompaniesListDataStyle-module__logo___lu59F";
var _13 = "CompaniesListDataStyle-module__margin-right___V2RMm";
var _14 = "CompaniesListDataStyle-module__margin-right___V2RMm";
var _15 = "CompaniesListDataStyle-module__text-right___wJ8W8";
var _16 = "CompaniesListDataStyle-module__text-right___wJ8W8";
export { _1 as "company-description", _2 as "company-details", _3 as "company-logo", _4 as "company-name", _5 as "companyDescription", _6 as "companyDetails", _7 as "companyLogo", _8 as "companyName", _9 as "item-details", _a as "item-raised", _b as "item-website-break", _c as "itemDetails", _d as "itemRaised", _e as "itemWebsiteBreak", _f as "keep-whitespace", _10 as "keepWhitespace", _11 as "label", _12 as "logo", _13 as "margin-right", _14 as "marginRight", _15 as "text-right", _16 as "textRight" }
